export function toTop() {
  document.querySelector('header')?.scrollIntoView();
}
